import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { queryClient } from "@/queryClient";

// PWA installata (standalone) → classe sul documento per adattare il layout
if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
  document.documentElement.classList.add("pwa");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
